import { BaseCrudService } from '@/services/_base/BaseCrudService'
import type { Tenant } from '@/types/Tenant'
import type { IFirestoreService } from '@/platform/firebase/firestore'

type Session = { tenantId?: string; yardId?: string; userId?: string }

export class TenantService extends BaseCrudService<Tenant> {
  constructor(firestore: IFirestoreService, session?: Session) {
    super('tenants', firestore, session)
  }

  protected beforeCreate(data: Partial<Tenant>): Partial<Tenant> {
    return {
      ...data,
      slug: data.slug || data.displayName?.toLowerCase().replace(/\s+/g, '-'),
      emailDomains: data.emailDomains || [],
      auth: data.auth || {
        tenantId: '',
        providers: ['password'],
        authorizedDomains: [],
      },
      createdAt: new Date(),
      updatedAt: new Date(),
      isDeleted: false,
    }
  }
}
